import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const FarmerJagrutiMeeting = () => {
  const data = [
    ['Month', 'Meetings Conducted'],
    ['January', 3],
    ['February', 4],
    ['March', 5],
    ['April', 4],
    ['May', 6],
  ];

  const options = {
    title: 'Farmer Jagruti Meetings',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Meetings Conducted' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#4CAF50'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default FarmerJagrutiMeeting;